import Modal from '@/components/common/Modal';
import { BRAND } from '@/config/brand';

type Props = {
  open: boolean;
  onClose: () => void;
};

const AgeRestrictionModal = ({ open, onClose }: Props) => {
  const appUrl = BRAND.domain;

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={appUrl}
      description="Responsible gambling"
      size="md"
    >
      {/* Content */}
      <div className="space-y-8 text-sm leading-relaxed text-shell-fg/85">
        {/* Over 18 Section */}
        <div className="space-y-2">
          <img src="/images/18plus.png" alt="18+" className="size-9" />

          <h3 className="text-base font-semibold text-shell-fg">Over 18s only</h3>

          <p>
            It is an offence for anyone under the age of 18 to open an account or to gamble on{' '}
            {appUrl}. {appUrl} takes its age-verification responsibilities very seriously. We carry
            out age-verification checks on all customers who use payment mechanisms which are
            available to under 18s and additionally perform random age-verification checks on
            customers using other forms of funding mechanisms. We may ask for information to verify
            your age and could restrict or suspend your account until your age is confirmed.
          </p>

          <p>
            PLEASE NOTE THAT ANYONE UNDER THE AGE OF 18 YEARS OLD FOUND TO BE USING THIS SITE WILL
            HAVE ANY WINNINGS FORFEITED AND MAY ALSO BE REPORTED TO THE POLICE.
          </p>
        </div>

        {/* Filtering Systems */}
        <div className="space-y-2">
          <h3 className="text-base font-semibold text-shell-fg">Filtering systems</h3>

          <p>
            {appUrl} advises and encourages its customers to prevent minors from accessing gambling
            websites.
          </p>

          <p>
            Filtering solutions allow parents to regulate access to the internet, based on chosen
            criteria. Parents can use filters to prevent their children from accessing, amongst
            other things, gambling websites. Because our pages are labelled, filtering solutions
            being used to prevent gambling access are able to detect our site content, and block our
            pages.
          </p>

          <p>
            If you share your computer with friends or family who are under the legal age to
            register or bet with our site, please consider parental filtering solutions such as:
          </p>

          <p>
            Net Nanny™ — <span className="text-gold">www.netnanny.com</span>
          </p>

          <p>
            CyberPatrol — <span className="text-gold">www.cyberpatrol.com</span>
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default AgeRestrictionModal;
